<template>
  <div id="orderingNotifs-page" style="padding-bottom: 2rem;">
    <h1 class="title is-2">{{paymentOption.name}}</h1>
    <div class="card" style="border-radius: 12px;max-width:800px;">
      <div class="card-content">
        <h1 class="title is-5">{{ $t('Orders.paymentType') }}</h1>
        <b-select :placeholder="$t('Orders.paymentType')" v-model="paymentOption.type"
        @input="(value)=>updatePaymentOptionName(value)"
        >
          
          <option value="cash">{{ $t('Orders.cash') }}</option>
          <option value="offline_payment">{{ $t('Orders.offlinePayment') }}</option>
          <option value="online_payment">{{ $t('Orders.onlinePayment') }}</option>
          <option v-if="$i18n.locale == 'ru'" value="yandexMoney">Яндекс.Касса</option>
          <option v-if="$i18n.locale == 'en'" value="toyyibpay">ToyyibPay</option>
          <option v-if="$i18n.locale == 'en'" value="stripe">Stripe</option>
         
        </b-select>
      </div>
      </div>

      <!-- Gateway details toyyibPay-->
      <div class="card" v-if="paymentOption.type == 'toyyibpay'" style="max-width:800px;">
        <div class="card-content" style="background-color: #a5dafb;border-radius: 6px;">
          <h1 class="title is-5" >{{ $t('Orders.toyyibPayDetails') }}</h1>
          <b-input class="order-email" placeholder="Secrey key" style="max-width:400px; margin-bottom:1rem;" type="text" v-model="gateway.userSecretKey" />
          <b-input class="order-email" placeholder="Category key" style="max-width:400px; margin-bottom:1rem;" type="text" v-model="gateway.categoryCode" />
          <p class="note"><span v-html="$t('Orders.toyyibPayDetailsNote')"></span></p>
        <b-button
        @click="saveGateway()"
        :loading="loading"
        type="is-success">
        {{ $t('DashboardTable.save') }}
        </b-button>
        </div>
      </div>
      <!-- Gateway details Stripe-->
      <div class="card" v-if="paymentOption.type == 'stripe'" style="max-width:800px;">
        <div class="card-content" style="background-color: #a5dafb;border-radius: 6px;">
          <h1 class="title is-5" >{{ $t('Orders.stripeDetails') }}</h1>
          <b-input class="order-email" placeholder="Publishable Key" style="max-width:400px; margin-bottom:1rem;" type="text" v-model="gateway.publicKey" />
          <b-input class="order-email" placeholder="Secrey key" style="max-width:400px; margin-bottom:1rem;" type="text" v-model="gateway.secretKey" />
          <p class="note"><span v-html="$t('Orders.stripeDetailsNote')"></span></p>
        <b-button
        @click="saveGateway()"
        :loading="loading"
        type="is-success">
        {{ $t('DashboardTable.save') }}
        </b-button>
        </div>
      </div>
      <!-- Gateway details yandexMoney-->
      <div class="card" v-if="paymentOption.type == 'yandexMoney'" style="max-width:800px;">
        <div class="card-content" style="background-color: #a5dafb;border-radius: 6px;">
          <h1 class="title is-5" >{{ $t('Orders.yandexMoneyDetails') }}</h1>
          <b-input class="order-email" placeholder="Секретный ключ" style="max-width:400px; margin-bottom:1rem;" type="text" v-model="gateway.secretKey" />
          <b-input class="order-email" placeholder="ShopId" style="max-width:400px; margin-bottom:1rem;" type="text" v-model="gateway.shopId" />
          <p class="note"><span v-html="$t('Orders.yandexMoneyDetailsNote')"></span></p>
      <b-button
        @click="saveGateway()"
        :loading="loading"
        type="is-success">
        {{ $t('DashboardTable.save') }}
        </b-button>
        </div>
      </div>


      <!-- Name for customers -->
      <div class="card" style="border-radius: 12px;max-width:800px;">
        <div class="card-content">
          <h1 class="title is-5">{{ $t('Orders.paymentNameForCustomers') }}</h1>
          <p class="note">{{ $t('Orders.paymentNameForCustomersNote') }}</p>
          <b-input class="order-email" style="max-width:400px;" type="text" v-model="paymentOption.name"
             />

        </div>
      </div>

      <!-- After payment Message -->
      <div class="card" v-if="paymentOption.type!=='free_delivery'" style="border-radius: 12px;max-width:800px;">
        <div class="card-content">
          <h1 class="title is-5">{{ $t('Orders.paymentMessageForCustomers') }}</h1>
          <p class="note">{{ $t('Orders.paymentMessageForCustomersNote') }}</p>
          <b-input class="" style="max-width:600px;" type="textarea" v-model="paymentOption.message"  />

        </div>
      </div>
      <b-button
        @click="saveInfo()"
        :loading="loading"
        type="is-success">
        {{ $t('DashboardTable.save') }}
        </b-button>
      <b-button
        @click="$router.go(-1)"
        type="is-text"
        >
        {{ $t('Dashboard.back') }}
        </b-button>
    </div>

</template>

<script>
        
import _ from "underscore";
import { mapActions, mapGetters } from "vuex";
import api from "@/api";

export default {
  name: "PaymentOptionEdit",
  components: {
   
  },
  props: [],
  computed: _.extend(
    {
      paymentOption() {
        return this.place.ordering.payment.options[this.$route.params.option]
      }
    },
    mapGetters({
    place: "getPlaceInfo"
  })
  ),

  data() {
    return {
      loading: false,
      gateway: {}
    }
  },
  
  methods: _.extend({}, mapActions(["updatePlaceInfo"]), {

    saveGateway() {
      this.loading = true
      let params = this.gateway;
      params.gatewayName = this.paymentOption.type
      params.url = this.place.url
      api.updateIntegrationDetails(params).then((resp)=>{
        console.log('updateIntegrationDetails:', resp);

        if (this.paymentOption.type == "stripe")
          this.paymentOption.publicKey = this.gateway.publicKey
        this.saveInfo()
        // this.loading = false
      })
    },
    
    saveInfo() {
      this.loading = true
      this.place.canPublish = "true"
      this.updatePlaceInfo(this.place).then(() => {
        this.loading = false
        this.$router.go(-1);
      });
    },
    updatePaymentOptionName(value) {
      console.log('value',value);
      let options = {
        en: {
          cash: "Cash",
          online_payment: "Online payment",
          offline_payment: "Offline payment",
          toyyibpay: "Online banking",
          yandexMoney: "Online payment",
          stripe: "Online payment"
        },
        ru: {
          cash: "Наличные",
          online_payment: "Оплата онлайн",
          offline_payment: "Оплата оффлайн",
          toyyibpay: "Оплата онлайн",
          yandexMoney: "Оплата онлайн",
          stripe: "Оплата онлайн",
        },
      }
      this.paymentOption.name = options[this.$i18n.locale][value];
      
    }
    }),
  mounted() {
    this.$ma.trackEvent({category: 'event', action: 'Page viewed: ' + this.$route.fullPath, label : null, value : null})
    this.$ma.trackEvent({category: 'event', action: 'Payment option updated', label : null, value : null})
  }
};
</script>

<style scoped>
.title {
  margin-bottom: 14px;
}
.note {
  margin-bottom: 10px;
}



</style>